var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatawhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.115,
    height: 14.831,
    viewBox: "0 0 17.115 14.831",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M26.928,18.508a2.77,2.77,0,0,1,1.237.289l3.665-5.032a.469.469,0,0,1,.758.552L28.922,19.35a2.784,2.784,0,1,1-3.963-.026c.032-.032.065-.063.1-.093L22.1,14.6a2.792,2.792,0,0,1-2.258-.043L16.418,19.5a.47.47,0,0,1-.773-.534l3.427-4.947-.02-.02a2.784,2.784,0,1,1,3.937,0c-.032.032-.065.063-.1.093l2.955,4.633a2.773,2.773,0,0,1,1.081-.217Z",
    transform: "translate(-15.562 -9.246)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatawhite);
export default __webpack_public_path__ + "static/media/datawhite.6d484561587091bf6e37110094bf9083.svg";
export { ForwardRef as ReactComponent };